import React from "react";
import { formatDateToLocal } from "../../helper/utils";
import "./EventSmallCard.css";

const EventSmallCard = ({
  eventTitle = "",
  eventType = "",
  time = "",
  date = "",
  location = "",
  image,
  onPress,
  onDecline,
  onAccept,
  showButtons = false,
  showRSVPButton = true,
  showAttendees = true,
  showExternalLink = true,
  status,
  isUsher,
  checkedInCount = 0,
  totalGuests = 0,
  usherStatusMessage,
  role,
}) => {
  const getStatusStyle = () => {
    switch (status) {
      case "Accepted":
        return "event-card-small-status-accepted";
      case "Declined":
        return "event-card-small-status-declined";
      case "Pending":
        return "event-card-small-status-pending";
      default:
        return "";
    }
  };

  const getStatusStyleForType = () => {
    return "event-card-small-eventType-background";
  };

  const formatEventDate = (dateString) => {
    return dateString;
  };

  return (
    <div className="event-card-small-card" onClick={onPress}>
      <div className="event-card-small-container">
        {image && (
          <div className="event-card-small-image-container">
            <img
              src={image}
              alt="Event"
              className="event-card-small-event-image"
            />
          </div>
        )}
        <div>
          <div className="event-card-small-content-container">
            <div className="event-card-small-header-row">
              {eventTitle && (
                <h3 className="event-card-small-title">{eventTitle}</h3>
              )}

              {showExternalLink && (
                <div className="event-card-small-external-link">
                  <svg width="26" height="26" viewBox="0 0 28 28" fill="none">
                    <rect width="32" height="32" rx="14" fill="#EEEFF0" />
                    <path
                      d="M16.2987 11.376L10.099 10.641L10.4246 8.50674L19.4144 10.2975L17.6237 19.2873L15.9893 18.9618L17.2243 12.761L8.7889 18.3951L7.86333 17.009L16.2987 11.376Z"
                      fill="#006216"
                    />
                  </svg>
                </div>
              )}
            </div>
            <div className="event-card-small-type-container">
              {status && status !== "pending" && (
                <span
                  className={`event-card-small-status-container ${getStatusStyle()}`}
                >
                  {status}
                </span>
              )}
              {status && eventType && (
                <span className="event-card-small-separator"> | </span>
              )}
              {eventType && (
                <span
                  className={`event-card-small-type-text ${getStatusStyleForType()}`}
                >
                  {eventType}
                </span>
              )}
            </div>
            <div className="event-card-small-details-container">
              <div className="event-card-small-detail-row">
                {time && (
                  <span className="event-card-small-detail-text">
                    <span className="event-card-small-icon">🕒</span> {time}
                  </span>
                )}

                {time && (date || location) && (
                  <span className="event-card-small-separator"> | </span>
                )}

                {date && (
                  <span className="event-card-small-detail-text">
                    <span className="event-card-small-icon">📅</span>{" "}
                    {formatEventDate(date)}
                  </span>
                )}
                {date && location && (
                  <span className="event-card-small-separator"> | </span>
                )}
                {location && (
                  <span className="event-card-small-detail-text">
                    <span className="event-card-small-icon">📍</span> {location}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>

        {isUsher && role === "usher" && (
          <div className="event-card-small-usher-stats-container">
            {/* <div className="event-card-small-usher-stats-content"> */}
            {/* <div className="event-card-small-stats-info">
                <span className="event-card-small-stats-label">
                  Checked-in Guests:
                </span>
                <span className="event-card-small-stats-value">
                  <strong>{checkedInCount}</strong> / {totalGuests}
                </span>
              </div> */}
            <button
              className="event-card-small-manage-button"
              onClick={(e) => {
                e.stopPropagation();
                onPress();
              }}
            >
              Manage Check-ins
            </button>
            {/* </div> */}
          </div>
        )}

        {usherStatusMessage && role === "usher" ? (
          <div className="event-card-small-status-message-container">
            <p
              className={`event-card-small-usher-status-message ${
                usherStatusMessage.includes("declined") ||
                usherStatusMessage.includes("declined")
                  ? "event-card-small-usher-declined"
                  : usherStatusMessage.includes("approved")
                  ? "event-card-small-usher-approved"
                  : "event-card-small-usher-pending"
              }`}
            >
              {usherStatusMessage}
            </p>
          </div>
        ) : showButtons && role !== "usher" ? (
          /* Guest Accept/Decline Buttons */
          <div className="event-card-small-buttons-container">
            <button
              className="event-card-small-decline-button"
              onClick={(e) => {
                e.stopPropagation();
                onDecline();
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#333333",
                }}
              >
                Decline
              </span>
            </button>
            <button
              className="event-card-small-accept-button"
              onClick={(e) => {
                e.stopPropagation();
                onAccept();
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#FFFFFF",
                }}
              >
                Accept
              </span>
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default EventSmallCard;
